export enum SystemAnnouncementType {
    WhatIsNew = 'What is New',
    Announcement = 'Announcement',
}

export interface SystemAnnouncement {
    id?: string;
    title: string;
    description?: string;
    type: SystemAnnouncementType;
    isActive: boolean;
    createdDate?: string;
    createdBy?: string;
    modifiedDate?: string;
    modifiedBy?: string;
}
